import { withTheme } from "@rneui/themed";
import React, { useEffect, useState } from "react";
import Toast from "react-native-toast-message";
import { Pressable } from "react-native";
import { PositionType, useUserUUID } from "@annunciate/core";
import { useBookmarkUpsertMutation, useBookmarksQuery, useIsEntitledQuery, } from "@annunciate/query";
import { BookmarkModal } from "./BookmarkModal";
import { getBookmarkInfo } from "../../utils";
import { FAIcon } from "../elements";
import { useProgress } from "../../hooks";
export const UnthemedBookmarkButton = React.forwardRef(({ item, size, activeIconColor, iconColor, buttonStyle, iconStyle, }, ref) => {
    const isEntitled = useIsEntitledQuery(item);
    const [isOpen, setIsOpen] = useState(false);
    const uuid = useUserUUID();
    const { data: progress } = useProgress(item.id);
    const { mutateAsync, error } = useBookmarkUpsertMutation();
    const { data: existingBookmarks } = useBookmarksQuery(item.id);
    const [existing, setExisting] = useState(undefined);
    const [progressValue, setProgressValue] = useState(undefined);
    useEffect(() => {
        if (progress?.position?.type === PositionType.EBOOK) {
            setProgressValue(progress.position.location.locations
                ?.totalProgression);
        }
        else if (progress?.position?.type === PositionType.TIME) {
            setProgressValue((progress?.position).value);
        }
    }, [progress]);
    useEffect(() => {
        const found = existingBookmarks?.find((bookmark) => {
            if (!bookmark?.position || (!progressValue && progressValue !== 0))
                return false;
            if (bookmark.position.type === PositionType.TIME) {
                const bookmarkTime = bookmark.position.value;
                const bounds = 5;
                return (progressValue > bookmarkTime - bounds &&
                    progressValue < bookmarkTime + bounds);
            }
            else if (bookmark.position.type === PositionType.EBOOK) {
                const existingLocation = bookmark.position.location
                    .locations?.totalProgression;
                return progressValue === existingLocation;
            }
            else {
                return false;
            }
        });
        setExisting(found);
    }, [progressValue, existingBookmarks?.length]);
    const onPress = async () => {
        if (!progress?.position) {
            Toast.show({
                type: "error",
                text1: `No position found`,
                autoHide: true,
                visibilityTime: 3000,
            });
            return;
        }
        if (existing) {
            Toast.show({
                type: "info",
                text1: `A bookmark already exists at ${getBookmarkInfo(existing, item).progress}`,
                text2: "Press to add a note.",
                autoHide: true,
                visibilityTime: 3000,
                onPress: () => {
                    setIsOpen(true);
                    Toast.hide();
                },
            });
            return;
        }
        try {
            const result = await mutateAsync({
                item: {
                    contentId: item.id,
                    position: progress.position,
                },
            });
            if (error)
                throw error;
            setExisting(result);
            Toast.show({
                type: "success",
                text1: `Saved a bookmark at ${getBookmarkInfo(result, item).progress}`,
                text2: "Press to add a note.",
                autoHide: true,
                visibilityTime: 3000,
                onPress: () => {
                    setIsOpen(true);
                    Toast.hide();
                },
            });
        }
        catch (error) {
            Toast.show({
                type: "error",
                text1: `There was an error creating your bookmark.`,
                autoHide: true,
                visibilityTime: 3000,
            });
        }
    };
    if (!uuid || !isEntitled) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Pressable, { onPress: () => onPress(), style: [{ paddingHorizontal: 15, paddingVertical: 10 }, buttonStyle] },
            React.createElement(FAIcon, { name: "bookmark", size: size, style: iconStyle, color: existing ? activeIconColor : iconColor })),
        isOpen && (React.createElement(BookmarkModal, { item: item, isOpen: isOpen, closeModal: () => setIsOpen(false), editItem: existing }))));
});
export const BookmarkButton = withTheme(UnthemedBookmarkButton, "BookmarkButton");
//# sourceMappingURL=BookmarkButton.js.map